<template>
  <div id="fy_sponsor" class="parent_container">
    <div class="sponsor_title">
      <h1 class="text-center">他们都选择使用<span>付帅</span></h1>
    </div>
    <img src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/index/fy_index_06.png" class="img-responsive">
  </div>
</template>

<script>
    import './../assets/css/fy_sponsor.css'

    export default {
        name: "fy_sponsor"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_sponsor.vue